import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map, tap } from 'rxjs';
import { CategoryConfigurationInheritedStoreActions } from '../category-configuration-inherited';
import { selectCurrentCategoryFromRouter } from '../router/router.selector';

/**
 * Resolver to fetch category inherited configurations before navigating to a route.
 * It dispatches an action to request the inherited category configuration based on the current category from the router.
 * @returns An observable that resolves to true when the action is dispatched.
 */
export const categoryConfigurationInheritedResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(selectCurrentCategoryFromRouter).pipe(
    filter((category) => !!category),
    first(),
    tap((category) => {
      store.dispatch(
        CategoryConfigurationInheritedStoreActions.CategoryConfigurationInheritedResolverActions.categoryConfigurationInheritedRequested(
          {
            categoryId: category.categoryId,
          }
        )
      );
    }),
    map(() => true)
  );
};
